module.exports = __webpack_public_path__ + "img/about-us.75c65815.png";